// extracted by mini-css-extract-plugin
export var cta = "SwaggerBanners-module--cta--6bdaa";
export var ctaText = "SwaggerBanners-module--ctaText--12998";
export var subtext = "SwaggerBanners-module--subtext--8b44c";
export var wrap = "SwaggerBanners-module--wrap--9730a";